import LinkDialog from '@/@core/components/admin/tag/LinkDialog.vue'
import { VuetifyTiptap, VuetifyViewer, createVuetifyProTipTap , BaseKit, Bold, Italic, Underline, Heading, SubAndSuperScript, Link } from 'vuetify-pro-tiptap'
import 'vuetify-pro-tiptap/style.css'

// RM-165: the Color extension (and its toolbar button) is intentionally removed
// so the member-update composer exposes only bold/italic/underline (+ heading,
// links). No font-family/size/color controls — content always inherits the
// standard email typography. Pasted styles are stripped via the
// `transformPastedHTML` editor prop wired where <VuetifyTiptap> is used.
export const vuetifyProTipTap = createVuetifyProTipTap({
  lang: 'en',
  components: {
    VuetifyTiptap,
    VuetifyViewer
  },
  extensions: [
    BaseKit.configure({
      placeholder: {
        placeholder: 'Enter some text...'
      }
    }),
    Bold,
    Italic,
    Underline,
    Heading,
    SubAndSuperScript.configure({ divider: true }),
    Link.configure({ dialogComponent: () => LinkDialog}),
  ]
})

// RM-165: strip inline font-family/size/color + <font> tags from pasted HTML
// so pasted content drops to the standard typography. Wire into the editor via
// `:editor-props="tiptapEditorProps"` on <VuetifyTiptap>.
const TYPOGRAPHY_PROPS = ['font-family', 'font-size', 'color']
export function stripPastedTypography(html) {
  if (!html) return html
  const stripDecls = value => value
    .split(';')
    .map(d => d.trim())
    .filter(Boolean)
    .filter(d => !TYPOGRAPHY_PROPS.includes(d.slice(0, d.indexOf(':')).trim().toLowerCase()))
    .join('; ')

  return html
    .replace(/<\/?font\b[^>]*>/gi, '')
    .replace(/style\s*=\s*"([^"]*)"/gi, (m, v) => {
      const cleaned = stripDecls(v)

      return cleaned ? `style="${cleaned}"` : ''
    })
    .replace(/style\s*=\s*'([^']*)'/gi, (m, v) => {
      const cleaned = stripDecls(v)

      return cleaned ? `style="${cleaned}"` : ''
    })
}

// Pass to <VuetifyTiptap :editor-props="tiptapEditorProps" />.
export const tiptapEditorProps = {
  transformPastedHTML: stripPastedTypography,
}